import React, { Component } from 'react';
//import { FormControl, FormGroup, Button } from 'react-bootstrap';
import Helmet from 'react-helmet';

import Hero from './content/Hero';
import Feature from './content/Feature';
import Card from './content/Card';
import LastCall from './content/LastCall';
import Footer from './content/Footer';
import WebfineryNavbar from './WebfineryNavbar';
import { Button } from 'react-bootstrap';
import mixpanel from "mixpanel-browser";
import { LinkContainer } from "react-router-bootstrap";
import axios from "axios";

import Newsletter from './Newsletter.js';

import './content/content.css';

import ContactModal from './ContactModal';


class ListsPage extends Component {

	constructor() {
		super();

		this.state = {
			contactModalVisible: false, fa: "", 
			contactModalTopic: "", 
			contactModalCue: "",
			contactModalPush: "",
			messageInputCollapsed: true,
			techCategoryMap: []
		};

		this.mixpanel = mixpanel;
		this.apiButtons = this.apiButtons.bind(this);
		this.searchButton = this.searchButton.bind(this);
		this.visitRankButton = this.visitRankButton.bind(this);
		this.consultingButton = this.consultingButton.bind(this);
		this.handleHideContactModal = this.handleHideContactModal.bind(this);
		this.handleContactUsClick = this.handleContactUsClick.bind(this);
	}

	componentDidMount () {
	  window.scrollTo(0, 0);
	  //this.getTechCategories();
	  //this.getTechs();
	  this.getData();
	}

	getData() {

		let techCategories = () => axios.get("/api/tech-categories");
		let tech = () => axios.get("/api/techs");

		let that = this;

		axios.all([techCategories(), tech()]).then(axios.spread(function(categoriesResponse, techsResponse) {
			let techCategoryMap = that.mapTechByCategoryName(that.addCategoryNameToTechs(categoriesResponse.data, techsResponse.data));			
			that.setState({ techCategoryMap : techCategoryMap });
		}))
		.catch(function(error) {			
                that.mixpanel.track("Get tech categories and/or tech failed", {
                    success: false,
                    error: error
                });                
                that.setState({error: true });
            });

	}

	getTechCategories() {
        let that = this;
        axios
            .get("/api/tech-categories", {
                params: { }
            })
            .then(function(response) {
            	let techCategories = that.sortCategoryList(response.data);
                that.setState({ techCategories: techCategories });

                that.mixpanel.track("Get tech categories", {
                    success: true
                });
            })
            .catch(function(error) {
                that.mixpanel.track("Get tech categories failed", {
                    success: false,
                    error: error
                });                
                that.setState({error: true, techCategories: []});
            });
    }

	getTechs() {
        let that = this;
        axios
            .get("/api/techs", {
                params: { }
            })
            .then(function(response) {
            	let techs = that.mapTechByCategoryId(response.data);
                that.setState({ techs: techs });

                that.mixpanel.track("Get techs", {
                    success: true
                });
            })
            .catch(function(error) {            	
                that.mixpanel.track("Get techs failed", {
                    success: false,
                    error: error      
                });                
                that.setState({error: true, techs: []});
            });
    }

    addCategoryNameToTechs(categoryList, techList) {
    	let categoryMap = this.mapObjectsByUniqueProperty(categoryList, 'id');
    	
    	for (let tech of techList) {
    		tech.categoryName = categoryMap[tech.categoryId].name;
    	}
    	
    	return techList;
    }

    mapTechByCategoryName(techList) {
    	return this.mapObjectsByNotUniqueProperty(techList, 'categoryName');
    }

    mapObjectsByUniqueProperty(list, propertyName) {
    	let map = {};
    	for (let obj of list) {
    		let id = obj[propertyName];    		
    		map[id] = obj;
    	}
    	return map;
    }

	mapObjectsByNotUniqueProperty(list, propertyName) {
    	let map = {};
    	for (let obj of list) {
    		let id = obj[propertyName];
    		map[id] = map[id] || [];
    		map[id].push(obj);
    	}
    	return map;
    }    

    mapTechByCategoryId(techList) {
    	let techMap = {};
    	for (let tech of techList) {
    		techMap[tech.categoryId] = techMap[tech.categoryId] || [];
    		techMap[tech.categoryId].push(tech);
    	}
    	return techMap;
    }

    sortCategoryList(categoryList) {    	
    	let sortedCategoryList = categoryList.sort((a, b) => {
    		let categoryNameCompare = a.name.localeCompare(b.name);
    		let subcategoryNameCompare = a.subcategoryName.localeCompare(b.subcategoryName);
    		return categoryNameCompare || subcategoryNameCompare;
    	});

    	return sortedCategoryList;
    }

	handleContactUsClick(techName) {
		this.setState({contactModalVisible: true, fa: "fa-envelope-open-o", contactModalTopic: "Order a list", 
			contactModalCue: techName,
			contactModalPush: "",
			messageInputCollapsed: true
		});
	}

	handleHideContactModal() {
		this.setState({contactModalVisible: false});
	}

	cloudHeroContent() {
		return (
			<div>
				<h1>Download Lists</h1>
		        <h2>Lists of websites using specific technologies</h2>
				<h3>Perfect prospecting starter</h3>
				<div>
					<Button bsSize="lg" bsStyle="success" onClick={() => this.handleContactUsClick('Please describe your requirements')}>Order your list</Button>
					<a href="#lists" className="btn btn-default btn-lg">See the lists</a>    				
				</div>
			</div>
		)
	}

	apiButtons(topic, optionalButton) {		
		return (
			<div>
				<div style={{float: 'right', marginTop: '15px'}}>
					{optionalButton}
		  			<Button bsSize="sm" onClick={this.handleContactUsApiClick}>Contact us</Button>
				</div>
			</div>
		)
	}

	searchButton() {
		return (
			<LinkContainer to='/search'>
  				<Button bsStyle="success" bsSize="small">See it in action</Button>
  			</LinkContainer>
		)
	}

	visitRankButton() {
		return (
			<a className="btn btn-success btn-sm" href="https://www.visitrank.com/" target="_blank">See it in action</a>
		)
	}

	consultingButton() {
		return (
			<LinkContainer to='/consulting'>
				<Button bsStyle="success" bsSize="small">Learn more</Button>
			</LinkContainer>
		)
	}

	renderTech() {
		return (
			<div className="text-center">
				{Object.keys(this.state.techCategoryMap).map(categoryName => (
					<div key={categoryName} className="techCategory">
						<h4>{categoryName}</h4>
						<div className="cardContainer">
							{this.state.techCategoryMap[categoryName].map(tech => (
								<Card key={tech.id} name={tech.name} domain={tech.domain} onDownloadRequest={() => this.handleContactUsClick(tech.name)}/>
							))}						
						</div>
					</div>
				))}
			</div>
		);
	}

  render() {
    return (
      <div className="Services">
      	<Helmet title="APIs &amp; Cloud Services" />
      	<WebfineryNavbar/>
      	<Hero>
      		{this.cloudHeroContent()}
      	</Hero>

      	<div id="lists" style={{marginTop: '40px'}} className="text-center">

      		<div style={{maxWidth: '1280px', margin: '0 auto'}}>

	      		<h2>A few examples...<br /><small>Contact us about <strong>any technology</strong></small></h2>

	      		{this.renderTech()}
	      	      		
	      		<div style={{marginBottom: '40px'}}>
		      		<Feature shade={true} borderless={true}>
		      			<h2>And many more...</h2>
		      			<h5>There is many more lists and technologies available.<br/><strong>Which one are you looking for?</strong></h5>
		      			<Button bsSize="large" bsStyle="success" onClick={() => this.handleContactUsClick('Please describe your requirements')}>Contact us</Button>
		      		</Feature>
		      	</div>
		      </div>

	      	<LastCall>
	      		<Newsletter/>
	      	</LastCall>

	    </div>
      	<Footer/>
		<ContactModal fa={this.state.fa} topic={this.state.contactModalTopic} message={this.state.contactModalMessage} 
    				contactModalCue={this.state.contactModalCue} contactModalPush={this.state.contactModalPush} 
    				visible={this.state.contactModalVisible} handleHide={this.handleHideContactModal} 
    				messageInputCollapsed={this.state.messageInputCollapsed}/>      	
      </div>
     );
	}
}

export default ListsPage;



// WEBPACK FOOTER //
// ./src/ListsPage.js